<p class="m-t-15">
{{TR 'Die Geräteauswahl ist dynamisch, das heißt die Menge der ausgewählten Geräte kann sich ändern. Sollten Sie einzelne Geräte auswählen, besteht die Gerätegruppe immer aus diesen Geräten. Die Filtereinstellungen werden dann nicht mitgespeichert.'}}
</p>
{{#if isFilter}}
{{#COMPARE filterCache.lastCount '>' 0}}
<div class="form-group m-t-15">
    <div class="checkbox checkbox-primary">
        <input
            data-config-name="{{name}}"
            id="select-devices-cb"
            class="js-select-devices-cb"
            type="checkbox"
            {{#if showSelectDevices}}checked="checked"{{/if}}
        >
        <label for="select-devices-cb"><strong>{{TR "Einzelne Geräte auswählen"}}</strong></label>
    </div>
</div>
{{else}}
<div class="alert alert-warning m-t-15">
{{TR 'Aktuell sind keine Geräte in der definierten Gruppe enthalten.'}}
</div>
{{/COMPARE}}
{{/if}}
<div class="form-group" id="{{selectionRegion}}"></div>
